import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=3142dfcb&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=3142dfcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142dfcb",
  null
  
)

export default component.exports